// @ts-check
import _ from 'lodash';

/**
 * @typedef {Object} ProviderClient
 * @property {string} providerId - The provider id
 * @property {string} providerClientId - The provider client id
 */

/**
 * Get the list of providers and provider clients from the assets in the list
 * @param {import('./types').AssetType[]} assets - List of assets
 * @returns {ProviderClient[]} List of provider and provider clients
 *
 */
export const getProviderClientList = (assets) => {

  // Get the list of provider clients from the assets
  const providerClients = _.compact(_.map(assets, (asset) => {
    return asset?.bindingData?.autobindRemoteInstanceIds;
  }));

  const updatedList = _.map(_.uniq(_.flattenDeep(providerClients)), (providerClient) => {
    const lst = providerClient.split('::');
    if (lst.length !== 2) {
      return null;
    }
    return {
      providerId: lst[0],
      providerClientId: lst[1]
    };
  });
  return _.compact(updatedList);
};

export const getProviderClientListFromAsset = (asset) => {
  // Get the list of provider clients from the assets
  const providerClients = _.compact(asset?.bindingData?.autobindRemoteInstanceIds);

  const updatedList = _.map(_.uniq(_.flattenDeep(providerClients)), (providerClient) => {
    const lst = providerClient.split('::');
    if (lst.length !== 2) {
      return null;
    }
    return {
      providerId: lst[0],
      providerClientId: lst[1]
    };
  });
  return _.compact(updatedList);
};

export const getFullProviderClientId = (providerId, providerClientId) => {
  return `${providerId}::${providerClientId}`;
};
